import React, { useEffect, useState } from "react";
import DashboardCalendar from "../DashboardCalendar";
import FinancialMetricsData from "./FinancialMetricsData";
import OwnerMetricsData from "./OwnerMetricsData";
import { formatDate } from "../../../../utilities/utils";
import moment from "moment";
import {
  useGetAdminMetricsQuery,
  useLazyGetAdminMetricsQuery,
} from "../../../../store/admin/adminMetrics";
import { calendarData } from "../adminData";
import { useDispatch } from "react-redux";
import { setLoader } from "../../../../store/reducers/globalLoaderSlice";
import { useGetProfessionsQuery } from "../../../../store/professions";

const AdminDataPage = () => {
  const dispatch = useDispatch();
    const { data: professions } = useGetProfessionsQuery();
  const [metricsData, setMetricsData] = useState({});
  const [calendarOpen, setCalendarOpen] = useState(false);
  const currentDate = moment();
  const startOfMonth = currentDate.startOf("month");
  const [selectRange, setSelectRange] = useState({
    startDate: moment().format("MM/DD/YYYY"),
    endDate: moment().format("MM/DD/YYYY"),
  });

  const [selectedCalendarFilter, setSelectedCalendarFilter] =
    useState("Today");
  const [selectedCompareFilter, setSelectedCompareFilter] = useState([
    "Previous period",
  ]);

  const {
    data: allAdminMetricsData,
    isSuccess: allAdminMetricsDataSuccess,
    isLoading: allAdminMetricsDataLoader,
  } = useGetAdminMetricsQuery({
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  });

  const [
    getAllAdminMetricsData,
    {
      data: adminMetricsData,
      isLoading: adminMetricsDataLoader,
      isSuccess: adminMetricsDataSuccess,
      isFetching: adminMetricsDataFetching,
    },
  ] = useLazyGetAdminMetricsQuery();

  const calendarFilterChange = (value) => {
    setSelectedCalendarFilter(value);

    const selectedPeriod =
      calendarData && calendarData?.find((item) => item.text === value)?.period;

    if (selectedPeriod) {
      setSelectRange({
        startDate: selectedPeriod.start,
        endDate: selectedPeriod.end,
      });
    } else {
      setSelectRange({});
    }
  };

  const compareFilterChange = (value, checked) => {
    setSelectedCompareFilter(value);
  };

  useEffect(() => {
    dispatch(setLoader(true));
    if (allAdminMetricsDataSuccess && !allAdminMetricsDataLoader) {
      setMetricsData(allAdminMetricsData?.data);
      dispatch(setLoader(false));
    }
  }, [allAdminMetricsDataSuccess]);

  useEffect(() => {
    if (adminMetricsDataSuccess && !adminMetricsDataLoader) {
      setMetricsData(adminMetricsData?.data);
      setCalendarOpen(false);
    }
  }, [adminMetricsDataSuccess, adminMetricsDataFetching]);

  const handleCalendarChange = (value, event) => {
    const startDate = formatDate(value[0]);
    const endDate = formatDate(value[1]);
    setSelectRange({ startDate: startDate, endDate: endDate });
    setSelectedCalendarFilter("Custom date");
  };

  const handleDateFilter = (professionId= null) => {
    const formattedStartDate = moment(
      selectRange.startDate,
      "MM/DD/YYYY"
    ).format("YYYY-MM-DD");
    const formattedEndDate = moment(selectRange.endDate, "MM/DD/YYYY").format(
      "YYYY-MM-DD"
    );
    if (selectedCalendarFilter === "All") {
      getAllAdminMetricsData({
        startDate: formattedStartDate,
        endDate: formattedEndDate,
        professionId:professionId
      });
    } else {
      getAllAdminMetricsData({
        startDate: formattedStartDate,
        endDate: formattedEndDate,
        professionId:professionId
      });
    }
  };

  const handleOpen = () => {
    setCalendarOpen((prevState) => !prevState);
  };

  const handleClose = () => {
    setCalendarOpen(false);
  };

  return (
    <div className="col-span-12">
      <div className="grid grid-cols-12 gap-6 mb-6">
        <div className="col-span-12 xl:col-span-8">
          <OwnerMetricsData
            metricsData={metricsData}
            handleClose={handleClose}
            handleOpen={handleOpen}
            calendarOpen={calendarOpen}
            setCalendarOpen={setCalendarOpen}
            handleDateFilter={()=>handleDateFilter()}
            selectRange={selectRange}
            setSelectRange={setSelectRange}
            calendarData={calendarData}
            selectedCalendarFilter={selectedCalendarFilter}
            calendarFilterChange={calendarFilterChange}
            selectedCompareFilter={selectedCompareFilter}
            compareFilterChange={compareFilterChange}
            handleCalendarChange={handleCalendarChange}
          />
        </div>
        <div className="col-span-12 xl:col-span-4">
          <div className="p-5 border border-[#EBEFF3] rounded-md bg-white">
            <DashboardCalendar />
          </div>
        </div>
      </div>
      <div>
        <FinancialMetricsData metricsData={metricsData} professions={professions}  handleProfessionChange={(professionId)=>handleDateFilter(professionId)}/>
      </div>
    </div>
  );
};

export default AdminDataPage;